import React from 'react';
import styles from './ContactRow.module.css';

const ContactRow = (props) => {
  return (
    <>
      <h1 className={styles.contact_sect_title}>{props.rowTitle}</h1>
      <div className={styles.contact_cards}>{props.children}</div>
    </>
  );
};

export default ContactRow;
